import { MinzeElement, EventListeners, Reactive } from 'minze'
import { Locale } from '../../modules/locale'
import { copyTextToClipboard, getVisibleWidth } from '../../modules/utils'
import { Font, SCREEN_WIDTHS } from '../../constants'
import { getContentTypeFromUrl } from '../../utils/gtm/utilities'
import MainModule from '../../modules/main'

Locale.getInstance().registerKeySet('fr', 'sharePopup', {
  copyLink: 'Copier le lien',
  linkCopied: 'Lien copié!',
  copy: 'Copier',
  share: 'Partager',
  facebook: 'Facebook',
  instagram: 'Instagram',
  x: 'X',
  linkedin: 'LinkedIn',
})

Locale.getInstance().registerKeySet('en', 'sharePopup', {
  copyLink: 'Copy link',
  linkCopied: 'Link copied!',
  copy: 'Copy',
  share: 'Share',
  facebook: 'Facebook',
  instagram: 'Instagram',
  x: 'X',
  linkedin: 'LinkedIn',
})

export interface LvcSharePopup {
  dataEventName: string
  linkCopied?: boolean
  isDesktop?: boolean
  pageUrl?: string
  iconWidth?: string
  iconHeight?: string
}

export class LvcSharePopup extends MinzeElement {
  attrs = ['data-event-name', 'unknown']
  reactive: Reactive = [
    ['linkCopied', false],
    ['isDesktop', true],
    ['pageUrl', ''],
  ]

  onReady(): void | Promise<void> {
    this.isDesktop = getVisibleWidth() > SCREEN_WIDTHS.TABLET

    if (!this.isDesktop) {
      this.iconWidth = '20px'
      this.iconHeight = '20px'
    }

    this.pageUrl = window.location.href.slice(0, 35) + '...'

    this.rerender()
  }

  onClose() {
    this.remove()
  }

  close() {
    let element = this.select('#modal')
    element?.setAttribute('close', 'true')
  }
  sendGtmEvent = (method: string) => {
    try {
      const mainModule = MainModule.getInstance()
      mainModule.analyticsTrack('share', {
        method: method,
        nom: this.dataEventName,
        content_type: getContentTypeFromUrl(window.location.pathname),
      })
    } catch (e) {
      console.error('Error tracking share event:', e)
    }
  }
  onCopyLink = () => {
    copyTextToClipboard(window.location.href)
    try {
      this.sendGtmEvent('copier')
    } catch (e) {
      console.error('Error tracking copy link:', e)
    }
    this.linkCopied = true
  }
  onFacebookShare = () => {
    window.open(
      'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(window.location.href)
    )
    try {
      this.sendGtmEvent('facebook')
    } catch (e) {
      console.error('Error tracking Facebook share:', e)
    }
    this.close()
  }
  onInstagramShare = () => {
    window.open('https://www.instagram.com/la_vitrine/')
    try {
      this.sendGtmEvent('instagram')
    } catch (e) {
      console.error('Error tracking Instagram share:', e)
    }
    this.close()
  }
  onXShare = () => {
    window.open(
      'https://twitter.com/share?url=' +
        encodeURIComponent(window.location.href) +
        '&text=' +
        encodeURIComponent(document.title)
    )
    try {
      this.sendGtmEvent('x')
    } catch (e) {
      console.error('Error tracking X share:', e)
    }
    this.close()
  }
  onLinkedInShare = () => {
    window.open(
      'https://www.linkedin.com/sharing/share-offsite/?url=' +
        encodeURIComponent(window.location.href)
    )
    try {
      this.sendGtmEvent('linkedin')
    } catch (e) {
      console.error('Error tracking LinkedIn share:', e)
    }
    this.close()
  }

  html = () => {
    return /*html*/ `
    <lvc-closeable-modal id="modal" modal-title="${Locale.getKey('sharePopup.share')}">
      <div>
        <div class="provider-section">
          <div class="provider-section-image-wrapper">
            <img class="provider-section-image" src="https://cloud.squidex.io/api/assets/lvc-dev/9d89302e-b999-443d-b369-0c1e12251b3c/marche.png?version=0&auto=true" width="235" height="235" loading="eager" />
          </div>
          <div class="providers">
              <div id="fb-share" class="provider-button">
                <div class="provider-icon-wrapper">
                  <lvc-share-facebook-icon class="provider-icon"></lvc-share-facebook-icon>
                </div>
                <span class="provider-label">${Locale.getKey('sharePopup.facebook')}</span>
              </div>
              <div id="ig-share" class="provider-button">
                <div class="provider-icon-wrapper">
                  <lvc-share-instagram-icon class="provider-icon"></lvc-share-instagram-icon>
                </div>
                <span class="provider-label">${Locale.getKey('sharePopup.instagram')}</span>
              </div>
     
            
              <div id="x-share" class="provider-button">
                <div class="provider-icon-wrapper">
                  <lvc-share-x-icon class="provider-icon"></lvc-share-x-icon>
                </div>
                <span class="provider-label">${Locale.getKey('sharePopup.x')}</span>
              </div>
              <div id="ld-share" class="provider-button">
                <div class="provider-icon-wrapper">
                  <lvc-share-linkedin-icon class="provider-icon"></lvc-share-linkedin-icon>
                </div>
                <span class="provider-label">${Locale.getKey('sharePopup.linkedin')}</span>
              </div>
          
          </div>

        </div>
        <div class="copy-link-title ${this.linkCopied ? 'copied' : ''}">
          ${Locale.getKey(this.linkCopied ? 'sharePopup.linkCopied' : 'sharePopup.copyLink')}
        </div>
        <div class="copy-link-body">
          <span class="copy-link-url">${this.pageUrl}</span>
          <div class="copy-link-button copy-link-text-button copy-link-desktop">${Locale.getKey('sharePopup.copy')}</div>
          <lvc-copy-icon class="copy-link-button copy-link-mobile"></lvc-copy-icon>
        </div>
      </div>
    </lvc-closeable-modal>
    `
  }

  css = () => `
    :host {
      display: inline;
    }

    .copy-link-title {
      font-weight: ${Font.weight.medium};
      font-size: 17px;
      line-height: 120%;
      color: #1E007D;
      margin-top: 40px;
      margin-bottom: 8px;
    }

    .copy-link-title.copied {
      color: #FF4600;
    }

    .copy-link-url {
      font-weight: ${Font.weight.medium};
      font-size: 14px;
      line-height: 150%;
      display: flex;
      align-items: center;
      color: #1E007D;
    }

    .provider-section {
      display: flex;
      justify-content: center;
      margin-top: 40px;
      margin-left: 0;
      gap: 24px;
      align-items: center;
    }
    .providers {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 24px;
    }

    .provider-button {
      display: flex;
      flex-direction: column;
      align-items: center;
      font-weight: ${Font.weight.medium};
      font-size: 14px;
      line-height: 150%;
      text-align: center;
      color: #1E007D;
      cursor: pointer;
    }

    .copy-link-body {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      padding: 12px;
      gap: 8px;

      height: 64px;

      /* Ciel */
      background: #BFF0FF;

      /* Inside auto layout */
      flex: none;
      order: 1;
      align-self: stretch;
      flex-grow: 0;

    }

    .copy-link-button {
      cursor: pointer;
    }

    .copy-link-text-button {
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      padding: 13px 16px;
      gap: 8px;
      isolation: isolate;
      width: 73px;
      height: 40px;
      border: 1px solid #1E007D;
      border-radius: 999px;
      flex: none;
      order: 1;
      flex-grow: 0;
      font-family: ${Font.family};
      font-style: normal;
      font-weight: ${Font.weight.medium};
      font-size: 12px;
      line-height: 120%;
      font-feature-settings: 'tnum' on, 'lnum' on;
      color: #1E007D;
    }

    .provider-label {
      margin-top: 8px;
    }

    .provider-icon {
      width: 80px;
      height: 80px;
      border: 1px solid #1E007D;
      border-radius: 999px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .provider-icon::part(icon) {
      width: 32px;
      height: 32px;
    }
    .provider-section-image {
      max-width: 225px;
      width: 100%;
      height: auto;
      aspect-ratio: 1;
      object-fit: cover;
    }

    @media screen and (max-width: 768px) {
      .copy-link-desktop {
        display: none;
      }
      .provider-section {
        gap: 16px;
      }
      .providers {
        gap: 16px;
        justify-content: center;
        align-items: center;
      }
      .provider-section {
        gap: 16px;
      }
      .providers {
        gap: 16px;
        justify-content: center;
        align-items: center;
      }
      .provider-icon {
        width: 50px;
        height: 50px;
      }
      .provider-icon::part(icon) {
        width: 20px;
        height: 20px;
      }
      .provider-label {
        font-size: 12px;
      }
      
    }
    @media screen and (min-width: 768px) {
      .copy-link-mobile {
        display: none;
      }
    }

  `

  eventListeners: EventListeners = [
    ['lvc-closeable-modal', 'close', this.onClose],
    ['.copy-link-button', 'click', this.onCopyLink],
    ['#fb-share', 'click', this.onFacebookShare],
    ['#ig-share', 'click', this.onInstagramShare],
    ['#x-share', 'click', this.onXShare],
    ['#ld-share', 'click', this.onLinkedInShare],
  ]
}
